import {
    Component,
    EventEmitter,
    HostListener,
    OnDestroy,
    OnInit,
    Output,
} from "@angular/core";
import {
    Observable,
    Subject,
    Subscription,
    forkJoin,
    interval,
} from "rxjs";
import { EmitterService } from "src/app/EmitterService";
import { AppService } from "src/app/app.service";
import { map, takeUntil } from "rxjs/operators";

@Component({
    selector: "app-navbar-style-three",
    templateUrl: "./navbar-style-three.component.html",
    styleUrls: ["./navbar-style-three.component.scss"],
})
export class NavbarStyleThreeComponent implements OnInit, OnDestroy {
    loadingData = true;
    isScrolled = false;
    isSmall: boolean;
    isBig = true;
    isLeft = true;
    isMiddle = false;
    subscription: Subscription;
    currentDay: string;
    currentTime: string;
    currentDate: string;
    Notices = [];
    array1 = [];
    array2 = [];
    AllmenuItems: any;
    currentDateTime$: Observable<string>;
    mainData: any;
    sortedNotice: any;
    private ngUnsubscribe = new Subject();
    @Output() parametersReady = new EventEmitter<any>();

    constructor(
        private appService: AppService,
        private emitterService: EmitterService
    ) {
        this.smallScreen();
    }

    ngOnInit(): void {
        this.currentDateTime$ = interval(1000).pipe(
            map(() => {
                const currentDate = new Date();
                const dayOfWeek = this.getDayOfWeek(currentDate);
                const time = this.getTime(currentDate);
                const month = this.getMonth(currentDate);
                const day = currentDate.getDate();
                const year = currentDate.getFullYear();
                return `${dayOfWeek} ${" | "}  ${time}  ${" | "}   ${month} ${day}, ${year}`;
            })
        );

        this.FetchMainData();
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next(null);
        this.ngUnsubscribe.complete();
    }

    FetchMainData() {
        forkJoin([
            this.appService.getClientBasics(),
            this.appService.getNotices(),
        ])
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
                (response: any) => {
                    console.log(response, "response FetchMainData");

                    this.mainData = response[0].data;

                    this.sortedNotice = this.sortByStartDate(response[1].data);

                    if (this.sortedNotice != null) {
                        let scrollFiltered = this.sortedNotice.filter(
                            (x) => x.ShowScroll === true
                        );

                        this.Notices = scrollFiltered.sort(
                            (a, b) => b.Id - a.Id
                        );

                        // localStorage.setItem('noticeData', JSON.stringify(this.Notices));
                    }

                    // if (this.mainData != null)
                    // {
                    //   let siteMapSorted = [];

                    //   this.mainData.SiteMapList
                    //     .forEach(item =>
                    //     {
                    //       if (item.ParentId === 0)
                    //       {
                    //         return;
                    //       }
                    //       let parentItem = siteMapSorted.find(parent => parent.Id === item.ParentId);
                    //       if (!parentItem)
                    //       {
                    //         parentItem = {
                    //           Id: item.ParentId,
                    //           MenuName: item.DisplayNameParent,
                    //           Items: []
                    //         };
                    //         siteMapSorted.push(parentItem);
                    //       }
                    //       parentItem.Items.push(item);
                    //     });

                    //   // console.log(siteMapSorted);

                    //   const middleIndex = Math.ceil(siteMapSorted.length / 2);

                    //   this.array1 = siteMapSorted.slice(0, middleIndex);
                    //   this.array2 = siteMapSorted.slice(middleIndex);

                    //   localStorage.setItem('mainData', JSON.stringify(this.mainData));
                    // }

                    // Starts all menu
                    if (this.mainData != null) {
                        let siteMapSorted = [];
                        // Filter out excluded MenuCodes (inactive menus)
                        let newArraay = [];

                        this.mainData.SiteMapList.forEach((item) => {
                            if (
                                item.MenuCode != 187 &&
                                item.MenuCode != 7 &&
                                item.MenuCode != 12 &&
                                item.MenuCode != 406
                            ) {
                                newArraay.push({
                                    ...item,
                                    Items: [],
                                });
                            }
                        });

                        // Initialize parent items with ParentId === 0, sorted by MenuOrder (serial)
                        newArraay
                            .filter((item) => item.ParentId === 0)
                            .sort((a, b) => (a.MenuOrder || 0) - (b.MenuOrder || 0))
                            .forEach((item) => {
                                siteMapSorted.push({
                                    ...item,
                                    Items: [],
                                });
                            });

                        // Nest the child items under their respective parents
                        newArraay.forEach((item) => {
                            if (item.ParentId !== 0) {
                                let parentItem = siteMapSorted.find(
                                    (parent) => parent.Id === item.ParentId
                                );
                                if (parentItem) {
                                    parentItem.Items.push(item);
                                }
                            }
                        });

                        // Inject custom 2nd layer sub-menus for Academic
                        let academicMenu = siteMapSorted.find((x) => x.MenuName && x.MenuName.includes("Academic"));
                        if (academicMenu) {
                            // Remove the old flat items from the dropdown list to avoid duplicates.
                            // We do this before injecting our new nested structured ones.
                            const itemsToHide = [
                                "College Class Routine", "School Class Routine", "Syllabus And Booklist",
                                "Bangla Version", "College", "English Version",
                                "Exam Routine College", "Exam Routine Bangla Version", "Exam Routine English Version",
                                "College Syllabus", "Syllabus Bangla Version", "Syllabus English Version",
                                "Academic Wings Bangla Version", "Academic Wings English Version",
                                "Class Routine College", "Class Routine Bangla Version", "Class Routine English Version",
                                "Academic Wings College"
                            ];

                            academicMenu.Items = academicMenu.Items.filter(x => {
                                if (x.MenuName) {
                                    const name = x.MenuName.trim();
                                    return !itemsToHide.includes(name);
                                }
                                return true;
                            });

                            let classRoutine = academicMenu.Items.find(x => x.MenuName.includes("Class Routine") || x.DisplayName.includes("Class Routine"));
                            let examRoutine = academicMenu.Items.find(x => x.MenuName.includes("Exam Routine") || x.DisplayName.includes("Exam Routine"));
                            let syllabus = academicMenu.Items.find(x => x.MenuName.includes("Syllabus") || x.DisplayName.includes("Syllabus") || x.MenuName.includes("SYLLABUS"));

                            if (!classRoutine) {
                                classRoutine = { MenuName: "Class Routine", DisplayName: "Class Routine", MenuUrl: "javascript:void(0)", Items: [], MenuOrder: 2 };
                                academicMenu.Items.push(classRoutine);
                            } else {
                                classRoutine.MenuName = "Class Routine";
                                classRoutine.DisplayName = "Class Routine";
                                classRoutine.MenuUrl = "javascript:void(0)";
                            }
                            classRoutine.Items = [
                                { MenuName: "College Class Routine", DisplayName: "College", MenuUrl: "/class-routine-college" },
                                { MenuName: "Bangla Version", DisplayName: "Bangla Version", MenuUrl: "/class-routine-bangla-version" },
                                { MenuName: "English Version", DisplayName: "English Version", MenuUrl: "/class-routine-english-version" }
                            ];

                            if (!examRoutine) {
                                // Assign a MenuOrder slightly higher than Class Routine so it appears right after
                                examRoutine = { MenuName: "Exam Routine", DisplayName: "Exam Routine", MenuUrl: "javascript:void(0)", Items: [], MenuOrder: 3 };
                                academicMenu.Items.push(examRoutine);
                            } else {
                                examRoutine.MenuName = "Exam Routine";
                                examRoutine.DisplayName = "Exam Routine";
                                examRoutine.MenuUrl = "javascript:void(0)";
                            }
                            examRoutine.Items = [
                                { MenuName: "College", DisplayName: "College", MenuUrl: "/exam-routine-college" },
                                { MenuName: "Bangla Version", DisplayName: "Bangla Version", MenuUrl: "/exam-routine-bangla-version" },
                                { MenuName: "English Version", DisplayName: "English Version", MenuUrl: "/exam-routine-english-version" }
                            ];

                            if (!syllabus) {
                                // Assign a MenuOrder somewhere in the middle
                                syllabus = { MenuName: "Syllabus", DisplayName: "Syllabus", MenuUrl: "javascript:void(0)", Items: [], MenuOrder: 15 };
                                academicMenu.Items.push(syllabus);
                            } else {
                                syllabus.MenuName = "Syllabus";
                                syllabus.DisplayName = "Syllabus";
                                syllabus.MenuUrl = "javascript:void(0)";
                            }
                            syllabus.Items = [
                                { MenuName: "College", DisplayName: "College", MenuUrl: "/college-syllabus" },
                                { MenuName: "Bangla Version", DisplayName: "Bangla Version", MenuUrl: "/syllabus-bangla-version" },
                                { MenuName: "English Version", DisplayName: "English Version", MenuUrl: "/syllabus-english-version" }
                            ];

                            let academicWings = academicMenu.Items.find(x => x.MenuName && (x.MenuName.includes("Academic Wings") || x.DisplayName.includes("Academic Wings")));
                            if (!academicWings) {
                                academicWings = { MenuName: "Academic Wings", DisplayName: "Academic Wings", MenuUrl: "javascript:void(0)", Items: [], MenuOrder: 4 };
                                academicMenu.Items.push(academicWings);
                            } else {
                                academicWings.MenuName = "Academic Wings";
                                academicWings.DisplayName = "Academic Wings";
                                academicWings.MenuUrl = "javascript:void(0)";
                            }
                            academicWings.Items = [
                                { MenuName: "College", DisplayName: "College", MenuUrl: "/academic-wings-college" },
                                { MenuName: "Academic Wings Bangla Version", DisplayName: "Bangla Version", MenuUrl: "/academic-wings-bangla-version" },
                                { MenuName: "Academic Wings English Version", DisplayName: "English Version", MenuUrl: "/academic-wings-english-version" }
                            ];
                        }

                        // Inject custom 2nd layer sub-menus for Result
                        let resultMenu = siteMapSorted.find((x) => x.MenuName && x.MenuName.includes("Result"));
                        if (resultMenu) {
                            const resultItemsToHide = ["HSC", "SSC", "HSC Results", "SSC Results", "HSC Result", "SSC Result"];
                            resultMenu.Items = resultMenu.Items.filter(x => {
                                if (x.MenuName) {
                                    const name = x.MenuName.trim();
                                    return !resultItemsToHide.includes(name);
                                }
                                return true;
                            });

                            let publicExam = resultMenu.Items.find(x => x.MenuName && (x.MenuName.includes("Public Exam") || x.DisplayName.includes("Public Exam")));
                            if (!publicExam) {
                                publicExam = { MenuName: "Public Exam", DisplayName: "Public Exam", MenuUrl: "javascript:void(0)", Items: [], MenuOrder: 1 };
                                resultMenu.Items.push(publicExam);
                            } else {
                                publicExam.MenuName = "Public Exam";
                                publicExam.DisplayName = "Public Exam";
                                publicExam.MenuUrl = "javascript:void(0)";
                            }
                            publicExam.Items = [
                                { MenuName: "HSC", DisplayName: "HSC", MenuUrl: "/hsc-results" },
                                { MenuName: "SSC", DisplayName: "SSC", MenuUrl: "/ssc-results" }
                            ];
                        }

                        // Inject custom 2nd layer sub-menus for Co-Curricular / Club
                        let clubMenu = siteMapSorted.find((x) => x.MenuName && (x.MenuName.includes("Club") || x.MenuName.includes("Activites") || x.MenuName.includes("Co-Curricular")));
                        if (clubMenu) {
                            const clubItemsToHide = [
                                "Physics", "Biology", "Chemistry", "Math",
                                "Science Club Physics", "Science Club Biology", "Science Club Chemistry", "Science Club Math",
                                "Bangla Language Club", "English Language Club",
                                "Drama Club", "Music Club", "Dance Club",
                                "Bangla Debate Club", "English Debate Club",
                                "Science Club", "Language Club", "Cultural Club", "Debate Club"
                            ];
                            clubMenu.Items = clubMenu.Items.filter(x => {
                                if (x.MenuName) {
                                    const name = x.MenuName.trim();
                                    return !clubItemsToHide.includes(name) && !name.includes("Science Club:");
                                }
                                return true;
                            });

                            let scienceClub = { MenuName: "Science Club", DisplayName: "Science Club", MenuUrl: "javascript:void(0)", Items: [], MenuOrder: 1 };
                            scienceClub.Items = [
                                { MenuName: "Physics", DisplayName: "Physics", MenuUrl: "/science-club-physics" },
                                { MenuName: "Biology", DisplayName: "Biology", MenuUrl: "/science-club-biology" },
                                { MenuName: "Chemistry", DisplayName: "Chemistry", MenuUrl: "/science-club-chemistry" },
                                { MenuName: "Math", DisplayName: "Math", MenuUrl: "/science-club-math" }
                            ];
                            clubMenu.Items.push(scienceClub);

                            let languageClub = { MenuName: "Language Club", DisplayName: "Language Club", MenuUrl: "javascript:void(0)", Items: [], MenuOrder: 2 };
                            languageClub.Items = [
                                { MenuName: "Bangla Language Club", DisplayName: "Bangla Language Club", MenuUrl: "/bangla-language-club" },
                                { MenuName: "English Language Club", DisplayName: "English Language Club", MenuUrl: "/english-language-club" }
                            ];
                            clubMenu.Items.push(languageClub);

                            let culturalClub = { MenuName: "Cultural Club", DisplayName: "Cultural Club", MenuUrl: "javascript:void(0)", Items: [], MenuOrder: 3 };
                            culturalClub.Items = [
                                { MenuName: "Drama Club", DisplayName: "Drama Club", MenuUrl: "/drama-club" },
                                { MenuName: "Music Club", DisplayName: "Music Club", MenuUrl: "/music-club" },
                                { MenuName: "Dance Club", DisplayName: "Dance Club", MenuUrl: "/dance-club" }
                            ];
                            clubMenu.Items.push(culturalClub);

                            let debateClub = { MenuName: "Debate Club", DisplayName: "Debate Club", MenuUrl: "javascript:void(0)", Items: [], MenuOrder: 4 };
                            debateClub.Items = [
                                { MenuName: "Bangla Debate Club", DisplayName: "Bangla Debate Club", MenuUrl: "/bangla-debate-club" },
                                { MenuName: "English Debate Club", DisplayName: "English Debate Club", MenuUrl: "/english-debate-club" }
                            ];
                            clubMenu.Items.push(debateClub);
                        }

                        // Inject custom 2nd layer sub-menus for Facilities
                        let facilitiesMenu = siteMapSorted.find((x) => x.MenuName && x.MenuName.includes("Facilities"));
                        if (facilitiesMenu) {
                            const facilitiesItemsToHide = ["Boys Hostel", "Girls Hostel"];
                            facilitiesMenu.Items = facilitiesMenu.Items.filter(x => {
                                if (x.MenuName) {
                                    const name = x.MenuName.trim();
                                    return !facilitiesItemsToHide.includes(name);
                                }
                                return true;
                            });

                            let hostel = facilitiesMenu.Items.find(x => x.MenuName && (x.MenuName.includes("Hostel") || x.DisplayName.includes("Hostel")));
                            if (!hostel) {
                                hostel = { MenuName: "Hostel", DisplayName: "Hostel", MenuUrl: "javascript:void(0)", Items: [], MenuOrder: 1 };
                                facilitiesMenu.Items.push(hostel);
                            } else {
                                hostel.MenuName = "Hostel";
                                hostel.DisplayName = "Hostel";
                                hostel.MenuUrl = "javascript:void(0)";
                            }
                            hostel.Items = [
                                { MenuName: "Boys Hostel", DisplayName: "Boys Hostel", MenuUrl: "/boys-hostel" },
                                { MenuName: "Girls Hostel", DisplayName: "Girls Hostel", MenuUrl: "/girls-hostel" }
                            ];
                        }

                        // Inject custom 2nd layer sub-menus for About Us
                        let aboutUsMenu = siteMapSorted.find((x) => x.MenuName && x.MenuName.toLowerCase().includes("about us"));
                        if (aboutUsMenu) {
                            const aboutItemsToHide = ["National", "International"];
                            aboutUsMenu.Items = aboutUsMenu.Items.filter(x => {
                                if (x.MenuName) {
                                    const name = x.MenuName.trim();
                                    return !aboutItemsToHide.includes(name);
                                }
                                return true;
                            });

                            let achievements = aboutUsMenu.Items.find(x => x.MenuName && x.MenuName.toLowerCase().includes("achievements"));
                            if (!achievements) {
                                achievements = { MenuName: "Achievements", DisplayName: "Achievements", MenuUrl: "javascript:void(0)", Items: [], MenuOrder: 9 };
                                aboutUsMenu.Items.push(achievements);
                            } else {
                                achievements.MenuName = "Achievements";
                                achievements.DisplayName = "Achievements";
                                achievements.MenuUrl = "javascript:void(0)";
                            }
                            achievements.Items = [
                                { MenuName: "National", DisplayName: "National", MenuUrl: "/national" },
                                { MenuName: "International", DisplayName: "International", MenuUrl: "/international" }
                            ];
                        }

                        // Sort sub-menu items by MenuOrder (serial) within each parent AFTER injecting custom items
                        siteMapSorted.forEach((parent) => {
                            parent.Items.sort(
                                (a, b) => (a.MenuOrder || 0) - (b.MenuOrder || 0)
                            );
                        });

                        this.AllmenuItems = siteMapSorted;
                        console.log(this.AllmenuItems, "Menu Items (sorted by MenuOrder)");

                        const middleIndex = Math.ceil(siteMapSorted.length / 2);

                        this.array1 = siteMapSorted.slice(0, middleIndex);
                        this.array2 = siteMapSorted.slice(middleIndex);

                        // Inject custom sub-menu items into mainData.SiteMapList
                        // so TemplatePageComponent can find them by MenuUrl and get the correct MenuCode
                        const existingUrls = new Set(this.mainData.SiteMapList.map((item) => item.MenuUrl));
                        const collectItems = (items) => {
                            const normalize = (str) => (str || '').toLowerCase().replace(/[^a-z0-9]/g, '');
                            items.forEach((parent) => {
                                if (parent.Items && parent.Items.length > 0) {
                                    parent.Items.forEach((child) => {
                                        // Find the original SiteMapList item by MenuName to get its MenuCode
                                        if (child.MenuUrl && child.MenuUrl !== 'javascript:void(0)' && !existingUrls.has(child.MenuUrl)) {
                                            const cNorm = normalize(child.MenuName);
                                            const originalItem = this.mainData.SiteMapList.find(
                                                (s) => {
                                                    const sNorm = normalize(s.MenuName);
                                                    return sNorm === cNorm ||
                                                           sNorm === `scienceclub${cNorm}` ||
                                                           sNorm === `languageclub${cNorm}` ||
                                                           sNorm === `debateclub${cNorm}` ||
                                                           sNorm === `culturalclub${cNorm}`;
                                                }
                                            );
                                            if (originalItem) {
                                                this.mainData.SiteMapList.push({
                                                    ...originalItem,
                                                    MenuUrl: child.MenuUrl,
                                                    DisplayName: child.DisplayName || originalItem.DisplayName
                                                });
                                                existingUrls.add(child.MenuUrl);
                                            }
                                        }
                                        // Also check grandchildren (3rd level)
                                        if (child.Items && child.Items.length > 0) {
                                            child.Items.forEach((grandChild) => {
                                                if (grandChild.MenuUrl && grandChild.MenuUrl !== 'javascript:void(0)' && !existingUrls.has(grandChild.MenuUrl)) {
                                                    const gNorm = normalize(grandChild.MenuName);
                                                    const origItem = this.mainData.SiteMapList.find(
                                                        (s) => {
                                                            const sNorm = normalize(s.MenuName);
                                                            return sNorm === gNorm ||
                                                                   sNorm === `scienceclub${gNorm}` ||
                                                                   sNorm === `languageclub${gNorm}` ||
                                                                   sNorm === `debateclub${gNorm}` ||
                                                                   sNorm === `culturalclub${gNorm}`;
                                                        }
                                                    );
                                                    if (origItem) {
                                                        this.mainData.SiteMapList.push({
                                                            ...origItem,
                                                            MenuUrl: grandChild.MenuUrl,
                                                            DisplayName: grandChild.DisplayName || origItem.DisplayName
                                                        });
                                                        existingUrls.add(grandChild.MenuUrl);
                                                    }
                                                }
                                            });
                                        }
                                    });
                                }
                            });
                        };
                        collectItems(siteMapSorted);

                        localStorage.setItem(
                            "mainData",
                            JSON.stringify(this.mainData)
                        );
                    }
                    if (this.sortedNotice != null && this.mainData != null) {
                        this.loadingData = false;
                        this.emitterService.changeMessage(true);
                        // this.parametersReady.emit(true);
                    }
                },
                (error) => {
                    // Handle errors
                    console.error("Error:", error);
                }
            );
    }

    private getDayOfWeek(date: Date): string {
        const days = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
        ];
        return days[date.getDay()];
    }

    private getTime(date: Date): string {
        const hours = date.getHours() % 12 || 12;
        const minutes = date.getMinutes();
        const ampm = date.getHours() < 12 ? "AM" : "PM";
        return `${hours}:${minutes < 10 ? "0" : ""}${minutes} ${ampm}`;
    }

    private getMonth(date: Date): string {
        const months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ];
        return months[date.getMonth()];
    }

    @HostListener("window:resize")
    onResize() {
        this.smallScreen();
    }

    @HostListener("window:scroll", [])
    onWindowScroll() {
        this.isScrolled = window.pageYOffset > 0;
    }

    smallScreen() {
        this.isSmall = window.innerWidth < 992;
        this.isBig = window.innerWidth >= 992;
        this.isLeft = window.innerWidth >= 992;
        this.isMiddle = window.innerWidth < 992;
    }

    onNavigate(url: string) {
        let MyUrl = "";
        if (url.startsWith("http://") || url.startsWith("https://")) {
            MyUrl = url;
        } else {
            MyUrl = "https://" + url;
        }
        window.open(MyUrl, "_blank");
    }

    NoAdmissionAlert() {
        alert("Admission services not open yet.");
        return;
    }

    private getTimeFull(date?: Date) {
        return date != null ? new Date(date).getTime() : 0;
    }

    public sortByStartDate(array: any): any {
        return array.sort((a: any, b: any) => {
            return (
                this.getTimeFull(b.CreatedDate) -
                this.getTimeFull(a.CreatedDate)
            );
        });
    }
}
